function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from 'react';
import { changeEmailErrorMessages, ViewType } from "../ChangeEmailAddressTypes";
import { Controller, useForm } from 'react-hook-form';
import { Button, TextField, Typography, useIsMounted } from 'seagull';
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import commonStyles from "../ChangeEmailAddress.module.scss";
import { emailValidation } from 'validators';
import { handleRequest } from "../../../infra/utils";
import { useStoreActions } from "../../../store/store-context";
import { ServerError } from "../../../infra/ErrorResponse";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SetUpNewEmail = _ref => {
  let {
    onClose,
    handleSetView,
    handleSetNewEmail
  } = _ref;
  const {
    api
  } = useStoreActions();
  const [isLoading, setIsLoading] = useState(false);
  const isMounted = useIsMounted();
  const {
    control,
    formState,
    handleSubmit,
    setError
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      newEmail: ''
    }
  });
  const handleSetUpNewEmail = async newEmail => {
    handleSetView(ViewType.VerifyNewEmail);
    handleSetNewEmail(newEmail);
    setIsLoading(false);
    return;
  };
  const handleError = error => {
    if (error.hasServerError(ServerError.EmailAlreadyRegistered)) {
      setError('newEmail', {
        message: changeEmailErrorMessages.emailAlreadyRegistered
      });
      return;
    }
    if (error.isTooManyAttemptsError()) {
      handleSetView(ViewType.TooManyAttempts);
      return;
    }
    setError('newEmail', {
      message: changeEmailErrorMessages.somethingWentWrong
    });
  };
  const sendNewEmail = async _ref2 => {
    let {
      newEmail
    } = _ref2;
    setIsLoading(true);
    const changeEmailResult = await handleRequest(api.user.changeUserEmail({
      email: newEmail
    }));
    if (changeEmailResult.success) {
      await handleSetUpNewEmail(newEmail);
    } else {
      handleError(changeEmailResult.error);
    }
    if (isMounted()) {
      setIsLoading(false);
    }
  };
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "set-up-new-email-address-view",
    children: /*#__PURE__*/_jsxs("form", {
      onSubmit: handleSubmit(sendNewEmail),
      children: [/*#__PURE__*/_jsxs("div", {
        className: commonStyles.content,
        children: [/*#__PURE__*/_jsxs(Typography, {
          variant: "paragraph1",
          "data-testid": "set-up-new-email-info-text",
          children: ["To verify your new email address, we\u2019ll send you a confirmation email ", /*#__PURE__*/_jsx("br", {}), " containing a one-time code."]
        }), /*#__PURE__*/_jsx(Controller, {
          control: control,
          name: "newEmail",
          rules: emailValidation(undefined, {
            required: true
          }),
          render: p => /*#__PURE__*/_jsx(TextField, _objectSpread({
            width: 360,
            "data-testid": "set-up-new-email-address",
            type: "email",
            label: "New email address"
          }, connectControllerToTextField(p)))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: commonStyles.footer,
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          skin: "primaryOutlineOpaque",
          "data-testid": "set-up-new-email-cancel-button",
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          type: "submit",
          "data-testid": "set-up-new-email-send-code-button",
          disabled: !formState.isValid,
          loading: isLoading,
          children: "Send code"
        })]
      })]
    })
  });
};
export default SetUpNewEmail;